module.exports = __webpack_public_path__ + "static/assets/5aeeafc514f8643a6ac06aaa54e31043.png";